import { API } from "../api/builder"
import { AxiosResponse } from "axios"
import { errorLogging, notify } from "../utils"
import { useConfig } from "../context/ConfigProvider";
import { ApiUrl, SessionKey } from "../utils/app-config"
import { ILocalUser } from "../typings/models/LocalUser"

export const useApiService = () => {

  const cfg = useConfig();
  const SERVER_URL = cfg.REACT_APP_API_BASE_URL;
  // API instance adds `x-api-key` and `Authorization` via interceptors

  const { handleHttpError } = errorLogging();
  const { message } = notify();

  const loginUser = async (localUser: any): Promise<any | null> => {
    let response: AxiosResponse<ILocalUser> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.User}`, localUser).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        return null;
    }
  }

  const ForcePassword = async (password: any): Promise<any | null> => {
    let response: AxiosResponse<ILocalUser> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.ForcePassword}`, password).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        return null;
    }
  }

  const ForgetPassword = async (email: any): Promise<any | null> => {
    let response: AxiosResponse<ILocalUser> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.ForgetPassword}`, email).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        return null;
    }
  }

  const ValidateToken = async (token: any): Promise<any | null> => {
    let response: AxiosResponse<ILocalUser> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.ValidateToken}`, token).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        return null;
    }
  }

  const ValidateResetPasswordToken = async (token: any): Promise<any | null> => {
    let response: AxiosResponse<ILocalUser> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.ValidateResetPasswordToken}`, token).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        return null;
    }
  }

  const ResetPassword = async (token: any): Promise<any | null> => {
    let response: AxiosResponse<ILocalUser> | void;
    response = await API.post(`${SERVER_URL}${ApiUrl.ResetPassword}`, token).catch(err => { handleHttpError(err, false) });
    if (response && response.status === 200) {
        return response.data;
    } else {
        return null;
    }
  }

  return {
    loginUser: loginUser,
    ForcePassword : ForcePassword,
    ForgetPassword : ForgetPassword,
    ValidateToken: ValidateToken,
    ValidateResetPasswordToken: ValidateResetPasswordToken,
    ResetPassword : ResetPassword
  }
}